import { motion } from "framer-motion";

export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <footer className="bg-black dark:bg-gray-950 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <motion.h3
              className="text-2xl font-playfair font-bold mb-4 hover-cursor"
              whileHover={{ scale: 1.05 }}
            >
              KASA
            </motion.h3>
            <p className="text-gray-400 mb-4">
              Elevating workspaces with premium office furniture designed for modern professionals.
            </p>
            <div className="flex space-x-4">
              <motion.a
                href="https://instagram.com/kasa.furniture"
                className="text-gray-400 hover:text-accent transition-colors duration-300 hover-cursor"
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <i className="fab fa-instagram text-xl"></i>
              </motion.a>
              <motion.a
                href="#"
                className="text-gray-400 hover:text-accent transition-colors duration-300 hover-cursor"
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <i className="fab fa-linkedin text-xl"></i>
              </motion.a>
              <motion.a
                href="#"
                className="text-gray-400 hover:text-accent transition-colors duration-300 hover-cursor"
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <i className="fab fa-facebook text-xl"></i>
              </motion.a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Products</h4>
            <ul className="space-y-2">
              {["Office Chairs", "Desks", "Storage Solutions", "Accessories"].map((item) => (
                <li key={item}>
                  <motion.button
                    onClick={() => scrollToSection("products")}
                    className="text-gray-400 hover:text-accent transition-colors duration-300 hover-cursor"
                    whileHover={{ x: 5 }}
                  >
                    {item}
                  </motion.button>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              {[
                { name: "About Us", id: "about" },
                { name: "Gallery", id: "gallery" },
                { name: "Blog", id: "blog" },
                { name: "Contact", id: "contact" },
              ].map((item) => (
                <li key={item.name}>
                  <motion.button
                    onClick={() => scrollToSection(item.id)}
                    className="text-gray-400 hover:text-accent transition-colors duration-300 hover-cursor"
                    whileHover={{ x: 5 }}
                  >
                    {item.name}
                  </motion.button>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Support</h4>
            <ul className="space-y-2">
              {["Customer Service", "Warranty", "Installation", "Maintenance"].map((item) => (
                <li key={item}>
                  <motion.button
                    className="text-gray-400 hover:text-accent transition-colors duration-300 hover-cursor"
                    whileHover={{ x: 5 }}
                  >
                    {item}
                  </motion.button>
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            &copy; 2024 KASA Furniture. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
